import {Component, Input} from '@angular/core';
import {StockItemHistory} from "../../modules/record/feature-print-models";
import {PortalApiService} from "../../modules/record/portal-api.service";
import {BaseService} from "../../modules/base/base.service";
import {NEVER, of, tap} from "rxjs";
import {Observable} from "rxjs/internal/Observable";

@Component({
    selector: 'ae-stock-item-history',
    templateUrl: './stock-item-history.component.html',
    styleUrls: ['./stock-item-history.component.scss']
})
export class StockItemHistoryComponent {
    public history: StockItemHistory[] = [];

    @Input() dataset: string | null = null;
    @Input() stockItemId: string | null = null;

    @Input() set setHistory(history: StockItemHistory[] | null) {
        if (history) {
            this.history = history;
        }
    }

    protected traceFileKey: string | null = null;
    protected downloadUrl: string | null = null;

    constructor(private recordApi: PortalApiService, private baseSvc: BaseService) {
    }

    generateDownload(traceFileKey: string) {
        if (this.dataset && this.stockItemId && traceFileKey) {
            this.downloadUrl = null;
            this.traceFileKey = traceFileKey;
            this.recordApi.getTraceDownloadUrl(traceFileKey, this.dataset, this.stockItemId).subscribe( download => {
                this.downloadUrl = download.downloadUrl;
            });
        }
    }

    formatAssetLink(traceFileKey: string): string {
        if (traceFileKey && traceFileKey.length > 1) {
            return traceFileKey.substring(traceFileKey.lastIndexOf('/')).replace("/", "");
        } else {
            return "";
        }
    }
}
